import React from 'react';
import { AlertCircle } from 'lucide-react';
import { COLORS, RADIUS, TYPOGRAPHY } from './design-tokens';

const ExcludedItemsCard = ({ items }) => {
  const list = items && items.length > 0 ? items : ['', '', '', ''];
  return (
    <div
      style={{
        background: COLORS.backgroundSecondary,
        border: `1px solid ${COLORS.line}`,
        borderRadius: RADIUS.card,
        padding: '10px',
        marginBottom: '6px'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          marginBottom: '8px'
        }}
      >
        <AlertCircle size={16} color={COLORS.primary} strokeWidth={2.5} />
        <span style={{ ...TYPOGRAPHY.sectionTitle, color: COLORS.textPrimary, letterSpacing: '1px' }}>
          ITENS NÃO INCLUSOS
        </span>
      </div>
      {list.map((item, i) => (
        <div
          key={i}
          style={{
            display: 'grid',
            gridTemplateColumns: '8px 1fr',
            alignItems: 'center',
            gap: '6px',
            marginBottom: i === list.length - 1 ? 0 : '6px'
          }}
        >
          <span style={{ color: COLORS.primary, fontSize: '14px', lineHeight: 1 }}>•</span>
          <div
            style={{
              borderBottom: `1px solid ${COLORS.line}`,
              fontSize: '11px',
              color: COLORS.textPrimary,
              paddingBottom: '3px',
              minHeight: '16px'
            }}
          >
            {item}
          </div>
        </div>
      ))}
      <div
        style={{
          fontSize: '9px',
          color: COLORS.textSecondary,
          marginTop: '6px',
          fontStyle: 'italic'
        }}
      >
        * Podem ser incluídos sob solicitação.
      </div>
    </div>
  );
};

export default ExcludedItemsCard;
